(function () {
  function initContentSlider(section) {
    if (!section || section.dataset.sliderInitialized === 'true') return;

    const track = section.querySelector('[data-slider-track]');
    const prevButton = section.querySelector('[data-slider-prev]');
    const nextButton = section.querySelector('[data-slider-next]');

    if (!track) return;

    section.dataset.sliderInitialized = 'true';

    const getScrollAmount = () => {
      const item = track.querySelector('.content-slider__item');

      if (!item) {
        return track.clientWidth;
      }

      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;

      return item.getBoundingClientRect().width + gap;
    };

    const updateButtons = () => {
      if (!prevButton && !nextButton) return;

      const maxScroll = track.scrollWidth - track.clientWidth;
      const currentScroll = track.scrollLeft;

      if (prevButton) {
        prevButton.disabled = currentScroll <= 2;
      }

      if (nextButton) {
        nextButton.disabled = currentScroll >= maxScroll - 2;
      }
    };

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        track.scrollBy({
          left: -getScrollAmount(),
          behavior: 'smooth'
        });
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        track.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });
      });
    }

    track.addEventListener(
      'scroll',
      updateButtons,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      updateButtons,
      { passive: true }
    );

    updateButtons();
  }

  function initAllContentSliders(root) {
    const scope = root || document;

    scope
      .querySelectorAll('[data-content-slider]')
      .forEach(initContentSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAllContentSliders();
      },
      { once: true }
    );
  } else {
    initAllContentSliders();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initAllContentSliders(event.target);
    }
  );
})();